import React from "react";
import {
  NewBox as Box,
  NewTable as Table,
  NewTypography as Typography,
  NewGrade as Grade,
  NewGradeValueOptions,
} from "@bca/ui-library";

import { BatteryGradesData } from "./BatteryGradesData";
import type { BatteryGradeDataItem } from "./BatteryGradesData";

import getBatteryGradeLetter from "../../utils/getBatteryGradeLetter";

interface BatteryGradesTableProps {
  batteryGrade: number | null;
}

const BatteryGradesTable: React.FC<BatteryGradesTableProps> = ({
  batteryGrade,
}) => {
  const getBatteryGradeScore = (
    batteryGrade: number,
    gradeItem: BatteryGradeDataItem
  ) => {
    const gradeLetter = getBatteryGradeLetter(batteryGrade);
    const isGradeMatch = gradeLetter === gradeItem.grade.toLowerCase();
    if (batteryGrade === null && isGradeMatch) {
      return "-";
    }
    return isGradeMatch ? batteryGrade : "";
  };

  return (
    <Table width="100%">
      <Table.Head>
        <Table.Row>
          <Table.HeadCell>BCA grade</Table.HeadCell>
          <Table.HeadCell>AVILOO State of Health % range</Table.HeadCell>
          <Table.HeadCell>Vehicle score</Table.HeadCell>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {BatteryGradesData.map((gradeItem) => (
          <Table.Row key={gradeItem.grade}>
            <Table.DataCell>
              <Box display="flex">
                <Grade
                  value={
                    getBatteryGradeLetter(
                      gradeItem.exampleScore
                    ) as NewGradeValueOptions
                  }
                />
                <Typography marginLeft="md" weight="heavy">
                  {gradeItem.grade}
                </Typography>
              </Box>
            </Table.DataCell>
            <Table.DataCell>
              <Typography weight="heavy">
                {gradeItem.scoreLabel}
              </Typography>
            </Table.DataCell>
            <Table.DataCell>
              <Typography weight="heavy">
                {getBatteryGradeScore(batteryGrade, gradeItem)}
              </Typography>
            </Table.DataCell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default BatteryGradesTable;
